import { useTenantStore } from '@/stores/tenant-store';

/**
 * Hook to access the current tenant slug (e.g. 'dgd', 'dgr') from Zustand store.
 *
 * Use this for tenant-aware conditionals in shared components — prefer it over
 * `useTenantName()` which returns the display name (e.g. "The Distinguished
 * Gentleman's Drive").
 *
 * @returns The tenant slug if in tenant context, null if in platform context
 */
export function useTenantSlug(): string | null {
  return useTenantStore((state) => state.slug);
}
